import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Checkbox, DatePicker, Empty, Icon, Input, Timeline} from 'antd';
import BaseComponent from "../../../base/BaseComponent";
import {Scrollbars} from "react-custom-scrollbars";
import ResourcePool from "./resourcePool/ResourcePool";
import {resourceFormatDate, uuid} from "../../../utils";
import TableList from "./resourcePool/Table";
import Position from "./Position";
import Pattern from "./Pattern";
import Detailpage from './DetailPage'
import {HEADER_HEIGHT} from "../../../constants";
import {message} from "../components/Mess";
import $ from "jquery";


let time;
export default class ComponentsList extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            currentId: '',
            virtualFileId: '',
            queryName: '',
            startTime: '',
            endTime: '',
            page: 1,
            size: 50,
            type: 'small',//小图标  大图标  中图标
            dataSource: [],
            sortField: 'type',//排序字段
            order: 1,//正序|倒序  1|-1
            checkArray: [],
            checkedStatus:'card',//当前选中的模式
            isAll: true,//是否全部加载
            modalKey:uuid(),
            selectedRowKeys:[],
            query:{
                Subdirectory:false
            },
            statusKey:'',
            isShowStop:false
        }
    }

    componentWillMount() {
    }

    componentDidMount() {


    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (!nextProps.Subdirectory || !nextProps.queryName) {
            if (time) {
                // this.clearInterval()
            }
        }
    }
    render() {
        return (
            <div>
                {/*渲染位置*/}
                {this.position()}
                {/*渲染数据*/}
                {this.renderData()}
                {this.state.checkedStatus!='list'?this.renderNextPage():null}
            </div>
        )
    }
    renderData() {
        let tableHeight = document.body.clientHeight - HEADER_HEIGHT - 30 - 190;
        let {dataSource,checkedStatus} = this.state;
        if(checkedStatus)
        return (
            <div>
                {
                    dataSource && dataSource.length ? <div>
                        {checkedStatus==='list'?this.Table(): <Scrollbars
                            autoHeight
                            autoHide
                            autoHeightMax={this.props.isEditor?420:tableHeight}
                            ref={(scrollRef) => {
                                this.scrollRef = scrollRef
                            }}
                            onScroll={this.onScroll.bind(this)}
                            onClick={() => {
                                this.setState({selectType: false}, () => {
                                    this.props.callBack && this.props.callBack(this.state.currentId, this.state.current, this.state.checkArray);
                                })
                            }}
                        >
                            {checkedStatus==='timeAxis' ? this.Timeline() : this.Card()}
                        </Scrollbars>}
                    </div> : <Empty style={{margin: "200px auto"}}/>
                }

                <Detailpage
                    key={this.state.modalKey}
                    onRef={ref => this.setDetailpage = ref}
                    onCloseCall={() => {
                        this.state.page = 1;
                        this.state.modalKey =  uuid()
                        this.setState({},()=>{
                            this.getList()
                        })
                    }}
                    dataList={this.state.dataSource}></Detailpage>
            </div>
        )
    }

    //时光轴模式
    Timeline = () => {
        let dataInfo = {};
        this.state.dataSource.forEach((item, index) => {
            let createTime = resourceFormatDate(item.createTime);
            if (!dataInfo[createTime]) {
                dataInfo[createTime] = {
                    createTime,
                    child: []
                }
            }
            dataInfo[createTime].child.push(item);
        });
        let list = Object.values(dataInfo); // list 转换成功的数据
        return (
            <div >
                {list.map((Item, index) => {
                    return (
                        <Timeline.Item key={index} style={{width: '100%'}}>
                            <div style={{cursor: 'pointer'}}
                            >{Item.createTime}</div>
                            <div style={{display: 'flex', marginTop: 20}}>
                                <div style={{width: '100%',}}>{
                                    Item.child && Item.child.map((item, index) => {
                                        return (
                                            <ResourcePool key={index}
                                                          type={this.state.type}
                                                          IsDownLoad={item.extendedAttributeJson && item.extendedAttributeJson.download ? item.extendedAttributeJson.download : false}
                                                          btnNames={this.props.btnNames}
                                                          title={item.name}
                                                          suffix={item.suffix?item.suffix:''}
                                                          createTime={resourceFormatDate(item.createTime)}
                                                          dataSource={this.state.dataSource}
                                                          img={item.icon} checked={item.checked}
                                                          fileType={item.fileType}
                                                          size={item.size?item.size:0}
                                                          applyDownload={()=>{
                                                              message.error('您没有所选资源的使用权限，请申请下载！')
                                                          }}
                                                          IsChecked={(e) => this.IsCheck(e, item)}
                                                          singleClick={() => this.singleClick(index, item)}
                                                          doubleClick={() => {
                                                              this.doubleClick(item, -1)
                                                          }}/>
                                        )
                                    })
                                }
                                </div>
                            </div>
                        </Timeline.Item>
                    )
                })}
            </div>
        )
    };

    //卡片模式
    Card = () => {
        return (
            <div>
                {
                    this.state.dataSource.map((item, index) => {
                        return (<ResourcePool key={index}
                                              type={this.state.type}
                                              title={item.name}
                                              IsShowChecked={item.fileTypeEnum}
                                              isEditor={this.props.isEditor}
                                              btnNames={this.props.btnNames?this.props.btnNames:[]}
                                              IsDownLoad={item.extendedAttributeJson && item.extendedAttributeJson.download ? item.extendedAttributeJson.download : false}
                                              createTime={resourceFormatDate(item.createTime)}
                                              dataSource={this.state.dataSource}
                                              img={item.icon} checked={item.checked}
                                              size={item.size?item.size:0}
                                              fileType={item.fileType}
                                              suffix={item.suffix?item.suffix:''}
                                              IsChecked={(e) => this.IsCheck(e, item)}
                                              singleClick={() => this.singleClick(index, item)}
                                              applyDownload={()=>{
                                                  message.error('您没有所选资源的使用权限，请申请下载！')
                                              }}
                                              doubleClick={() => {
                                                  this.doubleClick(item, index)
                                              }}/>)
                    })}
            </div>
        )
    };

    // 表格模式
    Table() {
        const {selectedRowKeys} = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                this.state.selectedRowKeys = selectedRowKeys;
                this.state.checkArray = selectedRows;
                this.setState({checkArray:selectedRows}, () => {
                    this.props.callBack && this.props.callBack(this.state.currentId, this.state.current, this.state.checkArray)
                })

            },
        };
        return (
            <TableList rowKey="id"
                       checkArray={this.state.checkArray}
                       current={this.state.current}
                       count={this.state.count}
                       btnNames={this.props.btnNames}
                       page={this.state.page}
                       size={this.state.size}
                       onClick={(record) => {
                           this.doubleClick(record, -1)
                       }}
                       rowSelection={rowSelection}
                       callBack={() => {
                               if (this.state.dataSource.length === 1) {
                                   this.onChangePage(this.state.page - 1, this.state.size)
                               } else {
                                   this.onChangePage(this.state.page, this.state.size)
                               }
                       }}
                       onChangePage={(page, size) => {
                           this.onChangePage(page, size)
                       }}
                       dataSource={this.state.dataSource}
            ></TableList>
        )
    }

    onChangePage(page, size) {
        this.setState({page: page, size: size}, () => {
            this.getList()
        })
    }

    /*监听滚动*/
    onScroll = e => {
        if (e.target.scrollTop + e.target.clientHeight === e.target.scrollHeight) {
            if(!this.state.query.Subdirectory){
                if (this.state.count > this.state.page * this.state.size) {
                    this.state.page = this.state.page + 1;
                    this.getList()
                }
            }
        }
    };
    //当前位置
    position() {
        return (
            <div style={{display: 'flex', justifyContent: 'space-between', lineHeight: '30px',margin: this.state.checkedStatus ==='list'?'20px 0px 0px 0px':'20px 0px'}}>
                <div><Position onRef={(position) => this.setPosition = position}
                               updateBtnStatus={(num) => {
                                   if (num > 1) {
                                       this.props.updateBtnStatus && this.props.updateBtnStatus(true)
                                   } else {
                                       this.props.updateBtnStatus && this.props.updateBtnStatus(false)
                                   }
                               }}
                               onSaveCallback={(id) => {
                                   //点击返回上一级的时候 刷新数据搜索列表
                                   this.props.empty && this.props.empty();

                                   this.setState({currentId: id,page:1}, () => {
                                       this.init();
                                       this.getPosition();
                                       this.getList();
                                       this.pattern&&this.pattern.initStatus();
                                       this.props.callBack && this.props.callBack(this.state.currentId, this.state.current, this.state.checkArray)
                                   })
                               }}>
                </Position>
                </div>
                <div>
                    {this.props.isEditor?null:<Pattern dataSource={this.state.dataSource}
                                                       count={this.state.count}
                                                       clearTimer={() => {
                                                           this.clearInterval(time);
                                                           this.setState({isAll:false})
                                                       }}
                                                       isShowStop={this.state.isShowStop}
                                                       Subdirectory={this.state.query.Subdirectory}
                                                       ref={(pattern) => {
                                                           this.pattern = pattern
                                                       }}
                                                       isAll={this.state.isAll}
                                                       callBack={(type, currentItem,currentSort,status) => {
                                                           this.SwitchingMode(type, currentItem,currentSort,status)
                                                           this.clearInterval(time)
                                                           this.setState({isAll:false})
                                                       }}>
                    </Pattern>}

                </div>
            </div>
        )
    }

    //切换模式
    SwitchingMode(type, currentItem,currentSort,status) {
      
        let cuttent = this.state.checkedStatus;
        this.state.type = type;
        this.state.checkedStatus=currentItem.type;
        this.state.sortField = currentSort.sortCondition;
        this.state.order = currentSort.sortType;
        this.state.checkArray = [];//切换模式下  将选中的数组清空
        this.state.page = 1;
        if (this.state.checkedStatus ==='list') {
            this.state.size = 10
        } else {
            this.state.size = 50
        }
        if(cuttent != this.state.checkedStatus ){
            this.state.dataSource =[];
            this.pattern&&this.pattern.init()
        }

        this.setState({}, () => {
            if(status){
                  this.getList()
             }
        })
    }

    //双击DetailAudio
    doubleClick(item, index) {

        clearTimeout(time);
        if (item.fileTypeEnum === 'DIR' || (item.fileTypeEnum === "LINK" && item.size === 0)) {
            this.props.empty && this.props.empty();
            this.pattern&& this.pattern.initStatus();
            this.setState({currentId: item.id, checkArray: [], page: 1, dataSource: [],isAll:true}, () => {
                    this.props.delete&&this.props.delete();
                    this.props.callBack && this.props.callBack(this.state.currentId, this.state.current, this.state.checkArray);
                    this.init();
                    this.getPosition();
                    this.getList()

                }
            )
        } else {
            if(!this.props.isEditor){
                let status=item.extendedAttributeJson && item.extendedAttributeJson.download ? item.extendedAttributeJson.download:false;
                if(!status){
                    this.setDetailpage.show(true, item, index,this.props.btnNames.indexOf('Rename')>-1)
                }else{
                    message.error("您没有所选资源的使用权限，请申请下载！")
                }

            }else{
                this.props.doubleClickCall && this.props.doubleClickCall(item)
            }
        }
    }

    //清除定时器
    clearInterval() {
        clearTimeout(time);
        this.setState({isShowStop:false},()=>{
            this.props.isDisabled&&this.props.isDisabled(this.state.isShowStop)
        });
    }

    IsCheck(e, item) {
        item.checked = e;
        if (item.checked) {
            this.state.checkArray.push(item)
        } else {
            this.state.checkArray = this.state.checkArray.filter(Item => Item.id !== item.id)
        }
        this.setState({}, () => {
            this.props.callBack && this.props.callBack(this.state.currentId, this.state.current, this.state.checkArray)
        });
        if(this.props.isEditor){
            this.props.isCheckCall && this.props.isCheckCall(this.state.checkArray)
        }
    }

    getRootName() {
        this.request({
            url: "/cm-sites-storage-management/zykRootDir/getCurrentUserRootDir",
            method: "get",
            body: {alias: this.props.tabName ? this.props.tabName : this.props.name},
            callBack: (data) => {
                if (data) {
                    this.setState({
                        currentId: data.virtualFileId,
                        current: data.virtualFileId,
                    }, () => {
                        this.props.callBack && this.props.callBack(this.state.currentId, this.state.current, this.state.checkArray);
                        this.getPosition();
                        this.getList()
                    })
                } else {
                    this.setState({dataSource: []});
                }
            }
        });
    }

    refreshList(){
        //如果是列表模式  返回到上一页
        if(this.state.checkedStatus==='list'){
             let count = this.state.count;
            let size = this.state.size;
            let page = this.state.page;
            let pageSum =Math.ceil( count/size);
            let dataLength = this.state.dataSource.length-this.state.checkArray.length;
                if(dataLength === 0){
                    if(pageSum == page){	//最后一页
                        page = page > 1 ? page-1 : 1
                    }else{
                        page = page
                    }
                }
                this.setState({selectedRowKeys:[]},()=>{
                    this.onChangePage(page,this.state.size)
                });
        }else {
            //如果是卡片模式或者时间轴模式

            this.state.page = 1;
            this.setState({}, () => {
                this.getList();
                // this.scrollRef.scrollTop(0)})

            })
        }
        this.cancelCheck()
    }
    //获取数据
    getList() {
        if(this.props.isEditor){
            this.state.checkArray = [];
            this.state.query.queryName = this.props.queryName?this.props.queryName:"";
            this.state.query.Subdirectory = this.props.Subdirectory?this.props.Subdirectory:'';
            this.state.query.IsRefresh = this.props.IsRefresh?this.props.IsRefresh:'';
        }
        //包含子目录
        if (this.state.query.Subdirectory &&this.state.query.queryName&&this.state.query.IsRefresh) {
            let parms = {
                fid: this.state.currentId,
                name: this.state.query.queryName ? this.state.query.queryName : '',
            };
            this.creatSearch(parms,(data)=>{
                if(data){
                    this.querySearch(parms,(res)=>{})
                }
            })
        } else {
            this.searchChildren()
        }
    };

    creatSearch(param,call){
        this.request({
            url: "/cm-sites-storage-management/zykFile/createSearch",
            method: "post",
            body: param,
            loading: false,
            callBack: (data) => {
                if (data) {
                    call(data)
                }
            }
        });
    }
    querySearch(param,call){
        this.request({
            url: "/cm-sites-storage-management/zykFile/querySearchResult",
            method: "post",
            body: param,
            callBack: (data) => {
                if(data){
                    this.state.count = data.count;
                    this.state.dataSource = data.virtualFileList;
                    if (data.completeTag) {
                        this.state.isAll =true;
                        this.state.isShowStop =false;
                        if(this.props.isEditor){
                            this.state.dataSource = data.allVirtualFileList.filter(item=> item.extendedAttributeJson && !item.extendedAttributeJson.download)
                            let  newAllVirtualFileList = data.allVirtualFileList
                            let noDownload = 0
                            for (let i = 0; i < newAllVirtualFileList.length; i++) {
                                if(newAllVirtualFileList[i].extendedAttributeJson && newAllVirtualFileList[i].extendedAttributeJson.download ){
                                    ++noDownload
                                }
                            }
                            this.state.count = data.count - noDownload
                        }else{
                            this.state.dataSource =data.allVirtualFileList;
                        }
                    } else {
                        this.state.isShowStop =true;
                        this.state.isAll =false;
                       time =  setTimeout(() => {
                              this.querySearch(param)
                        }, 1000)
                    }
                    this.props.isDisabled&&this.props.isDisabled(this.state.isShowStop)
                    if(this.props.isEditor){
                        this.props.getSelectNum && this.props.getSelectNum(this.state.count)
                        this.props.isDisabled&&this.props.isDisabled(this.state.isShowStop)
                    }
                    this.setState({},()=>{})
                }


            }
        });
    }

    searchChildren(){
        if(this.props.isEditor){
            this.state.query.queryName = this.props.queryName?this.props.queryName:""
        }
        let parms = {
            virtualFileId: this.state.currentId,
            page: this.state.page,
            size: this.state.size,
            filterJson: {
                queryName: this.state.query.queryName ? this.state.query.queryName : '',
                sortField: this.state.sortField,
                order: parseInt(this.state.order),
            }
        };
        let createTime = {};
        if (this.state.query.startTimeLong) {
            createTime.startTime = this.state.query.startTimeLong
        }
        if (this.state.query.endTimeLong) {
            createTime.endTime = this.state.query.endTimeLong
        }
        if (this.state.query.startTimeLong) {
            parms.filterJson.createTime = createTime
        }
        this.request({
            url: "/cm-sites-storage-management/zykFile/searchChildren",
            method: "post",
            body: parms,
            loading: false,
            contentType: 'json',
            callBack: (data) => {
                if(data){
                    this.state.count = data.count;
                }
                let newData = [];
                if (data && data.data && data.data.length) {
                    if(this.props.isEditor){
                        newData = data.data.filter(item => item.extendedAttributeJson && !item.extendedAttributeJson.download)
                        let  newDataCount = data.data
                        let noDownload = 0
                        for (let i = 0; i < newData.length; i++) {
                            if(newDataCount[i].extendedAttributeJson && newDataCount[i].extendedAttributeJson.download ){
                                ++noDownload
                            }
                        }
                        this.state.count = data.count - noDownload
                    } else {
                        newData = data.data
                    }
                }
                if (this.state.checkedStatus === 'list') {
                    this.state.dataSource = newData;
                    this.state.selectedRowKeys =[];
                    this.cancelCheck()
                } else {
                    if (this.state.page > 1) {
                        this.state.dataSource = [...this.state.dataSource, ...newData];
                    } else {
                        this.state.dataSource = newData
                    }
                }

                if(this.props.isEditor){
                    this.props.getNum && this.props.getNum(data.count)
                }
                this.setState({}, () => {
                    $('.ant-pagination-options-quick-jumper').find('input').val('')
                });
                // if (this.state.page === 1 && this.state.checkedStatus != 'list' && data.data.length) {
                //     this.scrollRef.scrollTop(0)
                // }
            }
        });
    }

    //获取位置

    getPosition=()=>{
        if(this.props.isEditor){
            this.props.getPositionCall && this.props.getPositionCall(this.state.currentId)
        }
        this.setPosition.getPosition(this.state.currentId, this.state.current);
    };
    //去掉选中数组的
    cancelCheck() {
        this.state.checkArray && this.state.checkArray.length && this.state.checkArray.forEach((item, index) => {
            item.checked = false
        });
        this.state.checkArray = [];
        this.setState({}, () => {
            this.props.callBack && this.props.callBack(this.state.currentId, this.state.current, this.state.checkArray)
        })
    }
    //初始化
    init(){
        this.state.checkedStatus='card';
        this.state.checkArray=[];
        this.state.page =1;
        this.state.query= {};
        if(!this.props.isEditor){
            this.pattern.init()
        }
        this.setState({},()=>{})
    }

    //获取数据里面得值
    setData(data){
       this.state.isShowStop =false;
        this.state.query=data;
        this.state.page =1;
        if(data.Subdirectory ===false){
            this.clearInterval()
        }
        this.setState({},()=>{
            if(data.IsRefresh){
                this.getList()
            }
        })
    }
    renderNextPage(){
        let count = this.state.count;
        let size = this.state.size;
        let page = this.state.page;
        let pageSum =Math.ceil( count/size);
        return(
            <>
                {this.props.isEditor?null:<div style={{height: "78px"}}><div style={{width:'120px',height:'40px',background:'#ffffff',justifyContent: "center",
                    display: "flex",
                    border: "1px solid #D9D9D9",
                    alignItems: "center",
                    position: "absolute",
                    bottom: '10px',
                    left:'50%',
                    marginLeft:'-60px',
                    zIndex:'999',
                    cursor: 'pointer',
                }}
                    onClick={()=>{
                    if(pageSum>1&&this.state.checkedStatus!='list'&&page!=pageSum){
                    this.state.page = this.state.page + 1;
                    this.getList()
                }

                }}
                    > {pageSum>1&&this.state.checkedStatus!='list'&&page!=pageSum?
                    <span> <Icon type="loading"  style={{fontSize:'20px',marginRight:5}}/>加载更多</span> :'已加载全部'}
                    </div>
                </div>
                }
            </>
        )
    }
}
